import { create } from '@bufbuild/protobuf'
import type { ConnectError } from '@connectrpc/connect'
import { useQuery } from '@connectrpc/connect-query'
import { listWorkflowGenerationTargetCandidates } from '@ebalance/proto/bffuser/v1/workflow_case_service-WorkflowCaseService_connectquery'
import {
  ListWorkflowGenerationTargetCandidatesRequestSchema,
  type ListWorkflowGenerationTargetCandidatesResponse,
} from '@ebalance/proto/bffuser/v1/workflow_case_service_pb'
import type { UseQueryResult } from '@tanstack/react-query'

/**
 * 業務ワークフローの BG コードに選べる発電の計画提出者コード (spec AC-WFW-003j)。
 * 受渡契約コードを導けるか (AC-IJM-010) の判定は backend が済ませた結果を返す。
 */
export function useListWorkflowGenerationTargetCandidates(options: {
  enabled: boolean
}): UseQueryResult<
  ListWorkflowGenerationTargetCandidatesResponse,
  ConnectError
> {
  return useQuery(
    listWorkflowGenerationTargetCandidates,
    create(ListWorkflowGenerationTargetCandidatesRequestSchema, {}),
    {
      enabled: options.enabled,
      // 失敗しても発電の候補が出ないだけにする (作成ダイアログ全体を error
      // boundary へ落とさない)。
      throwOnError: false,
    },
  )
}
